// extracted by mini-css-extract-plugin
module.exports = {"hidden":"StoreStock_hidden__YGZv0"};